import useAppDispatch from '../../../hooks/useAppDispatch';
import './SearchByImageHomeItemFeature.less';
import ImagePicker from '../../input/ImagePicker';
import useAppSelector from '../../../hooks/useAppSelector';
import { ProductSearchByImageMenuFeatureItem } from '../../../models/features/menu/ProductSearchByImageMenuFeatureItem';

const SearchByImageHomeItemFeature = () => {
    const dispatch = useAppDispatch();
    const menuFeatureItem = useAppSelector(
        state =>
            state.featureState
                .menuFeatureItem as ProductSearchByImageMenuFeatureItem
    );

    if (!menuFeatureItem) {
        return null;
    }

    return (
        <div className={`bri-SearchByImageHomeItemFeature`}>
            <ImagePicker
                onChange={imageDataUrl =>
                    dispatch.featureState.uploadImage({ imageDataUrl })
                }
            />
        </div>
    );
};

export default SearchByImageHomeItemFeature;
